import type { ReactNode } from 'react';

interface AccordionFieldProps {
  fieldName: string;
  label: string;
  isExpanded: boolean;
  onToggle: (fieldName: string) => void;
  children: ReactNode;
  summary?: string;
  testIdPrefix?: string;
}

export function AccordionField({
  fieldName,
  label,
  isExpanded,
  onToggle,
  children,
  summary,
  testIdPrefix = 'accordion',
}: AccordionFieldProps) {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          type="button"
          className={`accordion-button${isExpanded ? '' : ' collapsed'}`}
          aria-expanded={isExpanded}
          data-testid={`${testIdPrefix}-button`}
          onClick={() => onToggle(fieldName)}
        >
          {label}
          {summary && <span className="text-muted ms-2">{summary}</span>}
        </button>
      </h2>
      {isExpanded && (
        <div className="accordion-collapse" data-testid={`${testIdPrefix}-body`}>
          <div className="accordion-body">{children}</div>
        </div>
      )}
    </div>
  );
}
